module.exports = { 
      attributes: {"title":"Interne Turnierauswertung Januar 2023","categories":["shogi"],"tags":["shogi"],"language":"de","section":"shogi","slug":"internalgames202301"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Am 19.01.2023 fand unser erste internes Handicap Turnier im Jahr 2023 statt.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('data-table',{attrs:{"csvUrl":"/csv/hausliga/2023/202301.csv","hasRowNumbers":false,"columnLabels":['Platz', 'Name', 'Rang', 'Ligamodifier', 'Runde', '1', '2', '3', 'Punkte'],"boldedColumns":[0],"sortColumn":0}})],1),_vm._v(" "),_vm._m(1)]) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Turnierauswertung")])]) },function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Fumihiro erhält +1,"),_c('br'),_vm._v("\nRiku erhält -1,"),_c('br'),_vm._v("\nLigamodifier für die kommende Turniere.")]) }];
          }
        }
      },
     }